import React, { forwardRef } from 'react';
import { Observer } from 'mobx-react-lite';
import styled, { css } from 'styled-components';

const Input = styled.input`
  height: 36px;
  width: 100%;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.04);
  border: ${(p) => (p.error ? `1px solid ${p.theme.errorColor}` : '1px solid transparent')};
  ${(p) => p.bold && 'font-weight: bold'};
  font-size: 16px;
  color: ${(p) => p.theme.formInputColor || '#383838'};
  padding: 6px 12px 6px 12px;
  opacity: ${(p) => (p.disabled && !p.readOnly ? '0.65' : '1')};
  line-height: 22px;
  box-sizing: border-box;

  ${(p) =>
    !p.readOnly &&
    css`
      :focus {
        ${(p) => !p.error && `border: 1px solid ${p.theme.primaryColor}`};
        border-radius: 4px;
        outline: none;
      }
    `};

  ::placeholder {
    color: ${(p) => p.theme.purple80 || '#636383'};
    opacity: 0.3;
  }
`;

const Wrapper = styled.div`
  position: relative;
  margin-bottom: 4px;
`;

const IconContainer = styled.div`
  position: absolute;
  top: 6px;
  right: 10px;
`;

const Error = styled.span`
  color: ${(p) => p.theme.errorColor};
  font-size: 12px;
`;

export default forwardRef(({ type = 'text', icon, error, ...rest }, ref) => (
  <Observer>
    {() => (
      <Wrapper>
        <Input {...rest} error={error} type={type} ref={ref} spellCheck="false" />
        {icon && <IconContainer>{icon}</IconContainer>}
        <Error>{error}</Error>
      </Wrapper>
    )}
  </Observer>
));
